import React, { useState } from "react";
import PropTypes from "prop-types";
import { ArrowDownIcon } from "../../../../../components/Icons/ArrowDownIcon";

function CheckboxSimpleDropdown(props) {
  const { title, options, value, name, t, isLastest, onChange } = props;
  const [show, $show] = useState(true);
  const onChangeCheckbox = (e, val) => {
    const data = value;
    if (data.includes(val) == false) {
      data.push(val);
    } else {
      data.splice(data.indexOf(val), 1);
    }
    onChange(data);
  };

  return (
    <div
      className={
        "pt-[12px] pb-2 px-0" +
        (isLastest ? "" : "")
      }
    >
      <div
        className="flex items-center justify-between text-lg font-bold text-black cursor-pointer"
        onClick={() => $show(!show)}
      >
        <span>{title}</span>
        {show && <ArrowDownIcon className="rotate-180 w-[12px] h-[12px]" />}
        {!show && <ArrowDownIcon className="w-[12px] h-[12px]" />}
      </div>
      <div className={"mt-[10px]" + (show ? "" : " hidden")}>
        {options?.map((item, index) => {
          return (
            <label
              key={index}
              className="flex items-center justify-between py-2 cursor-pointer"
            >
              <span className="text-base text-black">{t(item.title)}</span>
              <input
                type="checkbox"
                name={name}
                value={item.value}
                onChange={($event) => onChangeCheckbox($event, item.value)}
                className={
                  "w-[24px] h-[24px] cursor-pointer border border-solid border-[#E5E8EB] rounded-[5px] bg-white" +
                  (value?.includes(item.value) ? " checkbox-checked" : "")
                }
              />
            </label>
          );
        })}
      </div>
    </div>
  );
}

CheckboxSimpleDropdown.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array,
  name: PropTypes.string,
  value: PropTypes.array,
  t: PropTypes.func,
  isLastest: PropTypes.bool,
  onChange: PropTypes.func,
};

export default CheckboxSimpleDropdown;
